import technotes from '../images/Technical_Notes_v0.2.pdf';

export default function TechNotes() {
    return (
        <iframe title='new_trial' style={{ height: '90vh' }} src={technotes}  className='iframe-content' loading="lazy" frameBorder="0" />
    )
}